<!--单条明细-->
<template>
  <el-dialog
    :title="pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="max-dialog1256" @close="afterCloseDialog">
    <div ref="print1" style="width: 98%;margin: 0 auto;">
      <!--库位号（页面左上角）-->
      <span v-if="storenum>0" style="float:left;">
        <b style="border:2px solid #333;border-radius:50%;padding:0 6px;font-size:20px;font-weight:bold;">{{storenum}}</b>
      </span>
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">
        {{printbaibao?(pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle).replace('销售订单','取货单'):(pagetitle.indexOf(';')!=-1?pagetitle.split(';')[0]:pagetitle)}}
       <div style="width: 640px;margin: 0 auto;text-align: right;"><img :src="imgpath"/></div>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="print-table">
        <tr class="noborder">
          <td align="right">货品名：</td>
          <td colspan="3"><div>{{seedname}} {{seedcode}}</div>
          <div v-if="subseedname&&(!isprint||printbaibao)" style="padding-left: 20px">{{subseedname}}</div></td>
          <td align="right">仓&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td>    {{controlData.cangkuname}}<!--&&btn!='填写发货单'-->
            <span style="font-size: larger" class="no-print"><b>{{controlData.warehousename}}</b></span>
            {{controlData.warehouse}}</td>
        </tr>
        <tr class="noborder">
          <td align="right">订单号：</td>
          <td>{{controlData.erpserial}}</td>
          <td align="right">时&nbsp;&nbsp;间：</td>
          <td>{{controlData.htqd||controlData.adddate}}</td>
          <td align="right">出&nbsp;&nbsp;库：</td>
          <td>{{controlData.status>350?controlData.handleoverdate:''}}</td>
        </tr>
        <tr class="noborder" v-if="!printbaibao">
          <td align="right" width="60">门&nbsp;&nbsp;店：</td>
          <td width="140"><span style="font-size: larger"><b>{{controlData.customername}}</b></span> {{controlData.customerserial}} {{controlData.shortname||''}}</td>
          <td align="right" width="60">地&nbsp;&nbsp;址：</td>
          <td width="220">{{controlData.deliveryaddress}}</td>
          <td align="right" width="60">联系人：</td>
          <td width="125">{{(controlData.linkman||"")+" " +((controlData.linkmantel&&controlData.linkmantel!='null')?controlData.linkmantel:'')}}</td>
        </tr>
        <tr class="noborder">
          <td align="right">运&nbsp;&nbsp;费：</td>
          <td>￥{{controlData.expressfee+" "+controlData.deliverymode}}</td>
          <td colspan="4" style="padding-left: 200px" v-if="!isprint&&(filltemplate==10||filltemplate==30)">
            <el-switch
            style="display: block" @change="changeTwo()"
            v-model="showallxy"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="全部显示"
            inactive-text="隐藏无数量列">
          </el-switch>
          </td>
        </tr>
        <tr v-show="showerweitable">
          <td colspan="6" style="border:none">
            <TwoDimensionalTable ref="referweibiao" :readonly="true" :needSetHeight="false" :needSetDisabled="false" :isshowprice="isshowprice" :price="price"></TwoDimensionalTable>
          </td>
        </tr>
        <tr v-show="showzuoyoutable">
          <td colspan="6" style="border:none">
            <el-col :span="2" style="text-align: right">右眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoright" :readonly="true" :needSetHeight="false" :needSetDisabled="false"></TwoDimensionalTable>
            </el-col>
            <el-col :span="2" style="text-align: right">左眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoleft" :readonly="true" :needSetHeight="false" :needSetDisabled="false"></TwoDimensionalTable>
            </el-col>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" style="padding-top: 5px;">说&nbsp;&nbsp;明：</td>
          <td colspan="5" style="border: none;height: 30px;padding-top: 5px;">
            <div v-html="getLiuYan(controlData.remark)">
            </div>
          </td>
        </tr>
        <tr class="noborder" style="height:46px">
          <td colspan="4">&nbsp;&nbsp;&nbsp;开单人员：{{controlData.ssfzr||""}}</td>
          <td colspan="2">出库人员：{{controlData.handleoveruname||""}}</td>
        </tr>
        <tr class="noborder" style="height:15px">
          <td colspan="4">&nbsp;</td>
          <td colspan="2"></td>
        </tr>
        <tr class="noborder">
          <td align="right">GZ.NO：</td>
          <td width="135">{{controlData.logisticstracknum||""}}</td>
          <td align="right">GY.NO：</td>
          <td colspan="3">
            <a @click="showSupplyOrder()" style="cursor: pointer;color: dodgerblue" v-if="controlData.tracknum&&controlData.tracknum.length>=14&&controlData.tracknum.substr(0,2)=='42'">{{controlData.tracknum||""}}</a>
            <a v-else>{{controlData.tracknum||""}}</a>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right">服务商：</td>
          <td>{{controlData.applybydname}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.address}}</td>
          <td align="right">联系人：</td>
          <td>{{(controlData.elinkman||"")+" "+(controlData.elinkmantel||"")}}</td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false;afterCloseDialog()">取 消</el-button>
      <el-button type="primary" @click="print1(false)">打印销货单</el-button>
      <el-button type="primary" @click="print1Noprice(false)" v-if="price['总价']">去价格打印</el-button>
      <el-button type="primary" @click="print1(true)" v-if="subseedname">打印取货单</el-button>
      <el-button type="primary" @click="exportExceltable" size="mini">导出</el-button>
      <span @click="printloglook" style="position: absolute;bottom: 8px;right: 10px">{{tips()}}</span>
    </div>
    <printlogList ref="printlogList"></printlogList>
    <Printtitle ref="Printtitle" @printtitlename="printtitlename"></Printtitle>
    <BuyfromList ref="BuyfromList"></BuyfromList>
  </el-dialog>
</template>

<script>
  import {getPrice} from '@/api/set/goodsprice';
  import {printing, checkprinting} from '@/api/set/csagreement';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getRemark, getKHRemark} from '@/plugin/ordercommon';
  import {save, getStoreNum} from '@/api/order/printlog';
  import {getModuleRight} from '@/api/login'
  import printlogList from './printlogList'
  import Printtitle from './Printtitle'
  import BuyfromList from '@/components/testorder/buyagreement/BuyfromList'

  export default {
    inject: ["afterCloseDialog"],
    name: 'CstagreementEditSeedDetail',
    data() {
      return {
        formLabelWidth: '120px',
        isprint: false,
        printbaibao:false,
        dialogSeeVisible: false,
        loading: true,
        showlookprice:false,
        pagetitle: '',
        seedcode: "",
        showallxy:false,
        seedname: '',
        subseedname:'',
        tableData: [],
        imgpath:'',
        column: [],
        controlData: {},
        erweitable: [],
        costpricebook: {},
        BookContent: [],
        BookContentLeft: [],
        BookContentRight: [],
        showtitle1: 'none',
        userInfoModel:{},
        filltemplate: "",
        showzuoyoutable: false,
        showerweitable: false,
        totalnumber: 0,
        gooodsXYBook:{},
        printDisplay: false,//打印是否显示价格
        isshowprice: true,
        price: {},//商品单价和总价
        uname: '',//打印人
        adddate: '',//打印时间
        storenum:0,
        binallocation:false,
      }
    },
    methods: {
      exportExceltable() {
        this.$refs.referweibiao.getExcel(this.controlData.erpserial + "【" + this.totalnumber + "片】" + this.seedname);
      },
      showSupplyOrder() {//显示供应商系统中的订单
        this.$refs.BuyfromList.show(this.controlData.tracknum, this.controlData.pcustomerserial);
      },
      getTitle(showname) {
        let result = [];
        if (showname && showname != '') {
          if (showname.indexOf(';') != -1) {
            var obj = showname.split(';')
            for (let i in obj) {
              if (obj[i] && i == 0) {
                result = obj[i]
              } else if (obj[i]) {
                result += ';' + obj[i]
              }
            }
          } else {
            result = showname
          }
        } else {
          let temp = localStorage.getItem("hpapi_userInfoModel")
          if (temp) {
            result += JSON.parse(temp).tenantname || ""
          }
        }
        if (result.indexOf(';') != -1) {
          var obj = result.split(';')
          for (let i in obj) {
            if (obj[i]) {
              if (this.controlData.voucherdetailguid) {
                obj[i] += "铺货单"
              } else {
                obj[i] += "销售订单"
              }
            }
          }
          result = obj.join(';')
        } else {
          if (this.controlData.voucherdetailguid) {
            result += "铺货单"
          } else {
            result += "销售订单"
          }
        }
        return result
      },
      showDetail(item) {

      },
      tips() {
        if (this.uname) {
          return "(打印人：" + this.uname + ",时间：" + this.adddate + ")"
        } else {
          return "(未打印过)"
        }
      },
      print1Noprice(printbaibao){
        this.isshowprice=false;
        this.print1(printbaibao);
      },
      //打印日志
      print1(printbaibao) {
        // window.print()
        this.printbaibao = printbaibao;
        this.showtitle1 = ""
        checkprinting({erpserial: this.controlData.erpserial, printtype: this.printbaibao?5:1}).then(response => {
          var printD = response.data.obj.rows;
          if (printD.length > 0) {//表示打印过，需要做出提醒
            this.$confirm('该订单“' + printD[0].uname + '”已于' + printD[0].adddate + '打印过，是否继续?', '提示', {
              confirmButtonText: '取消',
              cancelButtonText: '继续打印',
              type: 'error'
            }).then(() => {
            }).catch(() => {
              if (this.pagetitle.indexOf(";") != -1)
                this.$refs.Printtitle.show(this.pagetitle, false)
              else
                this.startprint(false);
            });
          } else {
            if (this.pagetitle.indexOf(";") != -1)
              this.$refs.Printtitle.show(this.pagetitle, true)
            else
              this.startprint(true);
          }
        });
      },
      printtitlename(pagetitle, needreflash) {
        this.pagetitle = pagetitle
        this.startprint(needreflash)
      },
      startprint(needreflash) {
        if (!this.printDisplay) {
          this.isshowprice = false
        }
        //获取库位号（状态350且拥有库位分配权限时）
        var storenumPromise = Promise.resolve(null);
        var self = this;
        if (this.binallocation && this.controlData.status == 350) {
          storenumPromise = getStoreNum({
            customerserial: this.controlData.customerserial,
            deliveryaddress: this.controlData.deliveryaddress
          }).then(response => {
            if (response.data.code == 0) {
              self.storenum = response.data.obj;
              return self.storenum;
            }
            return null;
          });
        }
        storenumPromise.then(() => {
          self.isprint = true
          self.$nextTick(() => {
            self.$print(self.$refs.print1)
            self.showtitle1 = "none"
            self.isshowprice = self.showlookprice
            self.isprint = false
            self.printbaibao=false
            save({erpserial: self.controlData.erpserial, invoicesource: 3, printtype: 1, deliveryaddress: self.controlData.deliveryaddress, customerserial: self.controlData.customerserial, storenum: self.storenum}).then(response => {
              if (response.data.code == 0) {
                if (needreflash) {
                  self.dialogSeeVisible = false
                  self.$emit("shuxiprint");//未打印过，刷新父页面
                }
                self.$message({
                  message: '生成打印日志',
                  type: 'success'
                })
              }
            })
          })
        })
      },
      printloglook() {
        this.$refs.printlogList.show()
        this.$refs.printlogList.initData(this.controlData.erpserial);
      },
      show(price) {
        this.dialogSeeVisible = true;
        if (price)
          this.price = price
      },
      getLiuYan(remark) {
        if (this.isprint) {
          return getKHRemark(remark);
        }
        return getRemark(remark);
      },
      initData(unitguid, seedcode, erpserial, filltemplate) {
        this.initForm()
        this.filltemplate = filltemplate
        this.seedcode = seedcode
        printing({
          unitguid: unitguid,
          erpserial: erpserial,
          seedcode: this.seedcode,
          filltemplate: this.filltemplate
        }).then(response => {
          //打印日志
          if (response.data.obj.printlogDOList.length > 0) {
            this.printData = response.data.obj.printlogDOList
            this.uname = this.printData[0].uname
            this.adddate = this.printData[0].adddate
          }

          //启用库位分配且状态350时，从当天打印记录中恢复库位号
          if (this.binallocation && response.data.obj.detail.status == 350) {
            var todayStr = this.formatTime().substring(0, 10);
            for (var idx = 0; idx < response.data.obj.printlogDOList.length; idx++) {
              var logItem = response.data.obj.printlogDOList[idx];
              if (logItem.storenum && logItem.storenum > 0) {
                var logDate = logItem.adddate ? logItem.adddate.substring(0, 10) : '';
                if (logDate == todayStr) {
                  this.storenum = logItem.storenum;
                  break;
                }
              }
            }
          }
          this.controlData = response.data.obj.detail;

          this.pagetitle = this.getTitle(response.data.obj.detail.printdname);
          this.imgpath = window.API_ROOT + "/api/avatar/getBarcode?content=" + this.controlData.erpserial
          this.printDisplay = (this.controlData.isshowprice.indexOf('4') != -1);
          if(this.printDisplay)
            this.isshowprice=true;

          if (this.controlData) {
            this.price['单价'] = this.controlData['pricetax']
            this.price['总价'] = this.controlData['htje']
          }
          this.BookContent = response.data.obj.goodsDetail
          this.seedname = response.data.obj.seedname
          this.subseedname=response.data.obj.subseedname
          this.BookContent.forEach(o => {
            this.totalnumber = this.totalnumber + o.P
          })
          if (!filltemplate)
            this.filltemplate = response.data.obj.filltemplate

          if(this.filltemplate==20){//定制片不用显示二维表
            this.showerweitable = true
            this.$refs.referweibiao.initBookFix(this.BookContent)
          }else {
            getPrice({seedcode: this.seedcode}).then(repPricebool => {
              this.gooodsXYBook = repPricebool.data.obj;

              if (this.filltemplate == "30") {
                this.showzuoyoutable = true
                this.BookContent.forEach(o => {
                  if (o.type == "L")
                    this.BookContentLeft.push(o)
                  else
                    this.BookContentRight.push(o)
                })
              } else {
                this.showerweitable = true
              }
              this.initBookBytype();
            })
          }
        });
      },
      changeTwo(){
        localStorage.setItem("twodimensional_showallxy",this.showallxy);
        this.initBookBytype();
      },
      initBookBytype(){
        if(this.showallxy){
          if (this.filltemplate == "30") {
            this.$refs.referweibiaoleft.initBook(this.gooodsXYBook,this.BookContentLeft)
            this.$refs.referweibiaoright.initBook(this.gooodsXYBook,this.BookContentRight)
            this.$refs.referweibiaoright.initBookFullFix();
            this.$refs.referweibiaoleft.initBookFullFix();
          } else {
            this.$refs.referweibiao.initBook(this.gooodsXYBook,this.BookContent)
            this.$refs.referweibiao.initBookFullFix();
          }
        }else {
          if (this.filltemplate == "30") {
            this.$refs.referweibiaoleft.initBookFix(this.BookContentLeft)
            this.$refs.referweibiaoright.initBookFix(this.BookContentRight)
          } else {
            this.$refs.referweibiao.initBookFix(this.BookContent);
          }
        }
      },
      initForm() {
        this.storenum = 0;
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
        this.gooodsXYBook={};
        this.imgpath=''
        this.BookContentLeft = []
        this.BookContentRight = []
        this.BookContent = []
        this.filltemplate = ""
        this.column = []
        this.tableData = []
        this.showzuoyoutable = false
        this.showerweitable = false
        this.totalnumber = 0
        this.printDisplay = false
        this.isshowprice = this.showlookprice//单价总价显示
      },
      formatTime(nowd) {
        var data = new Date();
        if (nowd) {
          data = new Date(nowd);
        }
        var year = data.getFullYear();
        var month = this.padString2(data.getMonth() + 1);
        var day = this.padString2(data.getDate());
        var hour = this.padString2(data.getHours());
        var minute = this.padString2(data.getMinutes());
        return year + '-' + month + '-' + day + " " + hour + ":" + minute;
      },
      padString2(str) {
        if (str < 10) return '0' + str;
        return str;
      },
    },
    mounted() {
      this.showallxy=localStorage.getItem("twodimensional_showallxy");
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      // 获取库位分配权限
      getModuleRight().then(reponse => {
        var rights = ';'+reponse.data.right +';';
        this.binallocation = rights.indexOf(';binallocation;') != -1;
      });
      if (this.userInfoModel.myright.indexOf('财务') != -1 || this.userInfoModel.myright.indexOf('查看订单价格') != -1) {
        this.showlookprice = true;
      } else {
        this.showlookprice = false;
      }
    },
    components: {
      TwoDimensionalTable,
      printlogList,
      Printtitle,
      BuyfromList
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementEditSeedDetail.vue